export default __webpack_public_path__ + "static/media/1774.f65da22b.png";